<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
	<div class="team-relation-mobile">
		<template v-for="(team, index) in currentTeam.Projects" :key="`${team.id}-${index}`">
			<div v-if="index < 2">
				<NuxtLinkLocale :to="getProjectLink(team)">
					<div class="team-teaser">
						<div class="row gx-3">
							<div class="col-5">
								<div class="team-teaser__image">
									<NuxtImg
										v-if="team['mainImage:url']"
										:src="completeImageUrl(team['mainImage:url'])"
										class="w-100 vh-12"
										loading="lazy"
                    :alt="team['mainImageMetadata']?.['alt'] || ''"
                    :title="team['mainImageMetadata']?.['title'] || ''"
										:class="{ 'special-img': team.id === 62 }"
                    sizes="500px"
									/>
								</div>
							</div>
							<div class="col-7 m-0">
								<div class="team-teaser__header">
									<h5 v-if="team.title">
										{{ team.title }}
									</h5>
									<div v-else>
										Kein Titel vorhanden !!!
									</div>
								</div>
								<div v-if="team.teaser" class="team-teaser__body">
									{{ team.teaser }}
								</div>
								<div v-else>
									Kein Teaser vorhanden !!!
								</div>
								<div class="team-teaser__button">
									<!-- The card is already a link; keep its CTA non-interactive. -->
									<span class="btn btn-icon-green">
										{{ translatedTexts.ButtonText }}
									</span>
								</div>
							</div>
						</div>
					</div>
				</NuxtLinkLocale>
			</div>
		</template>
	</div>
</template>

<script>
import { normalizeUrlPart } from '~/composables/useString'
import { usePimcoreAssetUrl } from '~/composables/usePimcoreAssetUrl'
import { getProjectRouteObject } from '~/composables/useDetailPageUrl'

export default {
	name: 'TeamRelation',
	// eslint-disable-next-line vue/require-prop-types
	props: {
		currentTeam: {
			type: Object,
			required: true
		},
		applySpecialClass: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			translatedTexts: {
				ButtonText: ''
			}
		}
	},
	computed: {
		routeName() {
			return 'projects-details-category-title'
		}
	},
	watch: {
		'$i18n.locale': 'translateTexts'
	},
	// eslint-disable-next-line vue/order-in-components
	filters: {
		truncateText(text, length) {
			if (text.length <= length) {
				return text
			} else {
				return text.substring(0, length) + '...'
			}
		}
	},
	mounted() {
		this.translateTexts()
	},
	methods: {
		getProjectLink(project) {
			return getProjectRouteObject({
				Title: project?.title,
        PrettyUrl: project?.prettyUrl,
        PublicUrlsByLocale: project?.PublicUrlsByLocale,
				Categories: project?.categories
			}, this.$i18n.locale, project?.categories?.[0]?.key)
		},
		normalizedCategoryTitle(categoryTitle) {
			return normalizeUrlPart(categoryTitle) || ''
		},
		normalizedTitle(title) {
			return normalizeUrlPart(title) || ''
		},
    completeImageUrl(imagePath) {
      if (!imagePath) {
        return '/images/no-image-placeholder.svg'
      }
      return usePimcoreAssetUrl(imagePath)
    },
		translateTexts() {
			this.translatedTexts.ButtonText = this.$t('moreButtonText')
		}
	}
}
</script>

<style lang="scss">
.team-relation-mobile {
	.team-teaser {
		margin-bottom: 1rem;
		h5 {
			margin-bottom: 10px;
		}
		.team-teaser__button {
			margin: 1rem 0;
		}
	}
	.team-teaser__header,
	.team-teaser__body {
		color: $white;
	}
	.team-teaser__body {
		font-size: 16px;
	}
	.team-teaser__image {
		.vh-12 {
			height: 150px;
			object-fit: cover;
		}
	}
	.special-img {
		object-position: -100px;
	}
	.btn-phone {
		padding: 10px;
	}
	.input-group {
		width: 95%;
		.form-control {
			border-radius: 0;
			color: $black;
			&::placeholder {
				color: $black;
			}
		}
	}
	.get-in-touch {
		margin-top: 8vh;
	}
}
</style>
